export default __webpack_public_path__ + "static/media/background_6.a24940fe.jpg";